module.exports = __webpack_public_path__ + "img/prata.e02627b9.png";